import { Severity } from './Severity';
var MessengerService = /** @class */ (function () {
    function MessengerService() {
        this._messages = [];
        this._delay = MessengerService.DEFAULT_DELAY;
        this.handleError = this.handleError.bind(this);
    }
    Object.defineProperty(MessengerService.prototype, "messages", {
        get: function () {
            return this._messages;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MessengerService.prototype, "delay", {
        set: function (delay) {
            this._delay = +delay || this._delay;
        },
        enumerable: true,
        configurable: true
    });
    MessengerService.prototype.showInfo = function (text, title, delay) {
        this.show(title, text, Severity.INFO, delay);
    };
    MessengerService.prototype.showSuccess = function (text, title, delay) {
        this.show(title, text, Severity.SUCCESS, delay);
    };
    MessengerService.prototype.showWarning = function (text, title, delay) {
        this.show(title, text, Severity.WARNING, delay);
    };
    MessengerService.prototype.showError = function (text, title, delay) {
        this.show(title, text, Severity.DANGER, delay);
    };
    MessengerService.prototype.showPrimary = function (text, title, delay) {
        this.show(title, text, Severity.PRIMARY, delay);
    };
    MessengerService.prototype.showSecondary = function (text, title, delay) {
        this.show(title, text, Severity.SECONDARY, delay);
    };
    MessengerService.prototype.showLight = function (text, title, delay) {
        this.show(title, text, Severity.LIGHT, delay);
    };
    MessengerService.prototype.showDark = function (text, title, delay) {
        this.show(title, text, Severity.DARK, delay);
    };
    MessengerService.prototype.show = function (title, text, severity, delay) {
        var _this = this;
        var message = {
            title: title,
            text: text,
            severity: severity
        };
        this._messages.unshift(message);
        if (delay !== 0) {
            delay = delay || this._delay;
            setTimeout(function () {
                _this.close(message);
            }, delay);
        }
    };
    MessengerService.prototype.close = function (message) {
        var index = this._messages.indexOf(message);
        if (index > -1) {
            this._messages.splice(index, 1);
        }
    };
    MessengerService.prototype.handleError = function (error) {
        console.error(error);
        var message;
        try {
            message = error.error && error.error.message || error.message;
        }
        catch (e) {
            message = '';
        }
        this.showError(message, 'Hiba!');
    };
    MessengerService.DEFAULT_DELAY = 5000;
    return MessengerService;
}());
export { MessengerService };



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/messenger/messenger.service.ts.pre-build-optimizer.js